'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('template-login', {
  onLoad: function onLoad() {
    var selectors = {
      recoverPasswordForm: '#RecoverPassword',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
      (0, _jquery2.default)('#RecoverPasswordForm').toggleClass('hide');
      (0, _jquery2.default)('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
      var $formState = (0, _jquery2.default)('.reset-password-success');

      // check if reset password form was successfully submited.
      if (!$formState.length) {
        return;
      }

      // show success message
      (0, _jquery2.default)('#ResetSuccess').removeClass('hide');
      (0, _jquery2.default)('#CustomerLoginForm').toggleClass('hide');
    }

    if ((0, _jquery2.default)(selectors.recoverPasswordForm).length) {
      checkUrlHash();
      resetPasswordSuccess();

      (0, _jquery2.default)(selectors.recoverPasswordForm).on('click', onShowHidePasswordForm);
      (0, _jquery2.default)(selectors.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
    }

    // stay-login cookie selectors
    (0, _jquery2.default)(function () {
      (0, _jquery2.default)("#StayLogin").change(function () {
        if ((0, _jquery2.default)(this).is(":checked")) {
          Cookies("stayloggin", (0, _jquery2.default)("#CustomerEmail").val(), { expires: 15 });
        }
      });
    });
  },
  onUnload: function onUnload() {}
});